import React from 'react';

const Logo = ({ className = '', variant = 'full' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="https://customer-assets.emergentagent.com/job_eco-drone-1/artifacts/qnuskx0h_logo%20v2.png"
        alt="PULVISTAR - Nettoyage par drone"
        className="h-auto w-auto"
        style={{ height: '78px' }}
      />
    </div>
  );
};

export default Logo;
